import { z } from 'zod';

/**
 * Auth service response schemas — matches auth service API responses.
 * These types represent data from VITE_AUTH_URL (PII + auth operations).
 */

export const AdminUserResponseSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string().nullable().optional(),
  isVerified: z.boolean(),
  isActive: z.boolean(),
  role: z.enum(['user', 'admin']),
  createdAt: z.string().datetime(),
});

export const AdminUserSearchResponseSchema = z.object({
  users: z.array(AdminUserResponseSchema),
  total: z.number().int().nonnegative(),
  limit: z.number().int(),
  offset: z.number().int(),
});

export const AdminBulkUserInfoSchema = z.object({
  email: z.string(),
  name: z.string().nullable().optional(),
  role: z.enum(['user', 'admin']),
  isActive: z.boolean(),
  isVerified: z.boolean(),
});

export const AdminBulkResolveResponseSchema = z.object({
  users: z.record(z.string(), AdminBulkUserInfoSchema),
});

// TypeScript types inferred from schemas
export type AdminUserResponse = z.infer<typeof AdminUserResponseSchema>;
export type AdminUserSearchResponse = z.infer<typeof AdminUserSearchResponseSchema>;
export type AdminBulkUserInfo = z.infer<typeof AdminBulkUserInfoSchema>;
export type AdminBulkResolveResponse = z.infer<typeof AdminBulkResolveResponseSchema>;
